import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon/Icon';

import './ShareIconSection.scss';

export default class ShareIconSection extends React.PureComponent {
    static propTypes = {
        /**
         * Orientation of icons
         */
        orientation: PropTypes.oneOf(['portrait', 'landscape']),
        /**
         * article meta data for social sharing
         */
        meta: PropTypes.shape({
            hostUrl: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            keywords: PropTypes.string.isRequired,
            social: PropTypes.shape({
                twitter: PropTypes.shape({
                    url: PropTypes.string.isRequired,
                    title: PropTypes.string.isRequired,
                    description: PropTypes.string.isRequired,
                    text: PropTypes.string.isRequired,
                    image: PropTypes.string.isRequired,
                }).isRequired,
                facebook: PropTypes.shape({
                    url: PropTypes.string.isRequired,
                    title: PropTypes.string.isRequired,
                    description: PropTypes.string.isRequired,
                    image: PropTypes.string.isRequired,
                }).isRequired,
            }),
        }).isRequired,
    };

    static defaultProps = {
        orientation: 'portrait',
        meta: {
            hostUrl: '',
            title: '',
            description: '',
            keywords: '',
            social: {
                twitter: {
                    url: '',
                    title: '',
                    description: '',
                    text: '',
                    image: '',
                },
                facebook: {
                    url: '',
                    title: '',
                    description: '',
                    image: '',
                },
            },
        },
    };

    render() {
        const meta = this.props.meta;
        const fbEncodeUrl = encodeURIComponent(meta.social.facebook.url);
        const twEncodeUrl = encodeURIComponent(meta.social.twitter.url);
        const encodedTitle = encodeURIComponent(meta.title);
        const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${fbEncodeUrl}`;
        const twitterURL = `https://twitter.com/intent/tweet/?text=${encodedTitle}&url=${twEncodeUrl}`;
        const shareUrl = `${meta.hostUrl}/share-with-friends`;

        //orientation
        const showLandscape =
            this.props.orientation === 'landscape' ? '' : 'd-none';
        const showPortrait =
            this.props.orientation === 'portrait' ? '' : 'd-none';
        return (
            <div className="component-Elements-ShareIconSection">
                <div className={`landscape ${showLandscape}`}>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3 className="grey">share this</h3>
                            <div className="icon-section">
                                <div className="icon d-inline-block">
                                    <a href={facebookURL} target="_blank">
                                        <Icon name="facebook" />
                                    </a>
                                </div>
                                <p>
                                    <span className="d-none d-lg-block">
                                        facebook
                                    </span>
                                </p>
                            </div>
                            <div className="icon-section">
                                <div className="icon d-inline-block">
                                    <a href={twitterURL} target="_blank">
                                        <Icon
                                            name="twitter"
                                            bgColor="black-bg"
                                        />
                                    </a>
                                </div>
                                <p>
                                    <span className="d-none d-lg-block">
                                        Twitter
                                    </span>
                                </p>
                            </div>
                            <div className="icon-section">
                                <div className="icon d-inline-block">
                                    <a href={shareUrl} target="_blank">
                                        <Icon name="email" />
                                    </a>
                                </div>
                                <p>
                                    <span className="d-none d-lg-block">
                                        Share with Friends
                                    </span>
                                </p>
                            </div>
                            <div className="icon-section">
                                <div className="icon d-inline-block">
                                    <a href={shareUrl} target="_blank">
                                        <Icon
                                            name="question"
                                            bgColor="black-bg"
                                        />
                                    </a>
                                </div>
                                <p>
                                    <span className="d-none d-lg-block">
                                        Share Anonymously
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`portrait text-left ${showPortrait}`}>
                    <h3 className="grey">share this</h3>
                    <div className="text-left">
                        <div className="icon d-inline-block">
                            <a href={facebookURL} target="_blank">
                                <Icon name="facebook" />
                            </a>
                        </div>
                        <p>facebook</p>
                    </div>
                    <div className="text-left">
                        <div className="icon d-inline-block">
                            <a href={twitterURL} target="_blank">
                                <Icon name="twitter" bgColor="black-bg" />
                            </a>
                        </div>
                        <p>Twitter</p>
                    </div>
                    <div className="text-left">
                        <div className="icon d-inline-block">
                            <a href={shareUrl} target="_blank">
                                <Icon name="email" target="_blank" />
                            </a>
                        </div>
                        <p>Share with Friends</p>
                    </div>
                    <div className="text-left">
                        <div className="icon d-inline-block">
                            <a href={shareUrl} target="_blank">
                                <Icon name="question" bgColor="black-bg" />
                            </a>
                        </div>
                        <p>Share Anonymously</p>
                    </div>
                </div>
            </div>
        );
    }
}
